import { sha256 } from 'js-sha256';

export const sha256Hash: (str: string) => string = (str: string): string => sha256(str);
